import {Fragment, Component} from 'react'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const SensorsdataProvider = dynamic(import('../utils/SensorsdataProvider'), {
  ssr: false,
  loading: () => null
})

export default class Layout extends Component {
  render () {
    const {metaData = {}} = this.props
    return (
      <Fragment>
        <Head>
          <title>{metaData.title}</title>
          {metaData.keywords ? <meta name="keywords" content={metaData.keywords} /> : null}
          {metaData.description ? (
            <Fragment>
              <meta name="description" content={metaData.description} />
            </Fragment>
          ) : null}
        </Head>
        {!process.env.CAVIAR_DEV && <SensorsdataProvider />}

        {this.props.children}
      </Fragment>
    )
  }
}
